import { h } from 'preact';
import IconSearch from '../utils/icon/search.svg';

const SearchForm = (searchForm) => (
  <form
    action={searchForm.routes_url}
    className={`${searchForm.darkLayout ? 'bg-[#353535]/30' : 'bg-[#F2F0EA]'}
      pl-[13px] pr-[11px] pt-[7px] pb-[6px]
      laptop:pt-2 laptop:pb-[7px] rounded-[5px] laptop:rounded-[4px] flex`}
  >
    <label htmlFor="inputSearch" className="sr-only">
      {window.TMW.Strings.header.search}
    </label>
    <input
      type="text"
      id="inputSearch"
      placeholder={`${window.TMW.Strings.header.search}...`}
      name="q"
      value={searchForm.search_value}
      className={`focus:outline-none border-none flex-1 bg-transparent
        pt-0 pr-[13px] pb-0 pl-0 utility-1 w-[73px] desktop:w-[177px]
        ${searchForm.darkLayout === true ? 'placeholder-white' : ''}`}
    />
    <button role="button" type="submit">
      <IconSearch />
    </button>
  </form>
);

export default SearchForm;
